import { render } from "./FormWizard.vue?vue&type=template&id=552d4844"
import script from "./FormWizard.vue?vue&type=script&lang=js"
export * from "./FormWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__